module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"initial-stage":"Initial stage: reports will be generated from here","deal-stage":"Won stage: reports will be generated up to here","show-more":"Show more","lost":"Lost"},"pt-BR":{"initial-stage":"Estágio inicial: os relatórios serão gerados a partir daqui","deal-stage":"Estágio de conversão: os relatórios serão gerados até aqui","show-more":"Mostrar mais","lost":"Abandonado"}}')
  delete Component.options._Ctor
}
